import request from '@/utils/request'

// 登录方法
export function login(data) {
  return request({
    url: '/share-car-manager/login/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 设置密码
export function updatePassword(data) {
  return request({
    url: '/share-car-manager/user/updatePassword',
    method: 'post',
    data: data
  })
}

// 用户信息
export function userView() {
  return request({
      url: '/share-car-manager/user/userView',
      method: 'get',
  })
}

// 获取用户菜单
export function queryUserMenuList() {
  return request({
      url: '/share-car-manager/role/queryUserMenuList',
      method: 'get',
  })
}

// 退出
export function logout(data) {
  return request({
    url: '/share-car-manager/index/countData',
    method: 'post',
    data: data
  })
}

// 获取登录验证值
export function generateCaptcha() {
  let uuid = sessionStorage.getItem("captcha_uuid"),
    data = {};
  if(uuid){
    data.uuid = uuid
  }
  return request({
    url: '/share-car-manager/api/shareMngUser/generateCaptcha',
    method: 'post',
    data
  })
}